import './red-star.scss';

import '@/utils/common.js';
import ScrollAnim from '@/utils/scroll-anim.js';
import initLeaderIntroduction from '@/components/leader-introduction_zh/leader-introduction_zh.js';

new ScrollAnim();
initLeaderIntroduction();

$(function () {
    if ($(window).outerWidth() < 768) {
    } else {
        let $timeline = $('.time-line').data({ animStatus: false });
        function handlePageScroll() {
            if (
                $(document).scrollTop() >=
                    $timeline.offset().top +
                        $timeline.outerHeight() / 2 -
                        $(window).outerHeight() &&
                !$timeline.data('animStatus')
            ) {
                $timeline.data({ animStatus: true }).addClass('into-page');
            }
        }
        handlePageScroll();
        $(document).scroll(handlePageScroll);
    }

    $('a[href*="#"]:not([href="#"])').on('click', function () {
        if (
            location.pathname.replace(/^\//, '') ==
                this.pathname.replace(/^\//, '') &&
            location.hostname == this.hostname
        ) {
            let $target = $(this.hash);
            $target = $target.length
                ? $target
                : $('[name=' + this.hash.slice(1) + ']');
            if ($target.length) {
                $('html, body').animate(
                    {
                        scrollTop: $target.offset().top,
                    },
                    {
                        duration: 1200,
                        easing: 'easeInOutQuad',
                    }
                );
                return false;
            }
        }
    });
});
